import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { WorkflowDetails } from "./components/WorkflowDetails";

export function WorkflowPage() {
  return (
    <LqsPage title="Workflow Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <WorkflowDetails />
      </Container>
    </LqsPage>
  );
}
